// Services
import { get } from 'svelte/store';
import { postReq } from '../services/http';
// Stores
import { home_data } from 'src/stores/account/user';
import { format } from 'svelte-i18n';
import type { DiscountDetailsType } from 'src/types/DiscountType';

/**
 * Function to save key in home_data
 * @param id Key to save
 * @param data Value of the key
 * @returns Response of the request
 */
export const save_home = async (id, data) => {
	const res = await postReq('interface/home/save', {
		data: JSON.stringify(data),
		id,
	});

	if (res?.isok) {
		home_data.update((home_data) => {
			home_data[id] = data;
			return home_data;
		});
	} else {
		console.error('Failed to change the chart type for home.');
	}
	return res;
};

export const DEVICE_LIST_HOME_KEY = 'device_list';

export type DeviceListHomeData = {
	type?: string;
	columns?: string[];
	[key: string]: unknown;
};

/**
 * `save_home` replaces the whole key. Merge into the current `device_list`
 * object so view type and column order don't wipe each other.
 */
export const saveDeviceListSettings = async (partial: DeviceListHomeData) => {
	const current = get(home_data)?.[DEVICE_LIST_HOME_KEY];
	const merged = {
		...(current && typeof current === 'object' && !Array.isArray(current) ? current : {}),
		...partial,
	};
	return save_home(DEVICE_LIST_HOME_KEY, merged);
};

/**
 * Function to delete a key from home_data
 * @param id Key to delete
 * @returns Response of the request
 */
export const delete_home = async (id) => {
	const res = await postReq('interface/home/delete', {
		id,
	});

	if (res.isok) {
		home_data.update((home_data) => {
			delete home_data[id];
			return home_data;
		});
	} else {
		console.error('Failed to delete home data.');
	}
	return res;
};

export const formatOrdinal = (key) => {
	const number = parseInt(key, 10);

	if (Number.isNaN(number)) {
		return '';
	}

	const suffix =
		number % 100 >= 11 && number % 100 <= 13 ? 'th' : ['th', 'st', 'nd', 'rd'][number % 10] || 'th';

	return get(format)(`key_${suffix}`, { default: `${number}${suffix}`, values: { number } });
};

export const g1DHasValidExpiry = (items: DiscountDetailsType[]) => {
	const now = Date.now();

	return items.some(({ expiry }) => {
		const expiryTimestamp = Date.parse(`${expiry.toString().split(' ')[0]}T23:59:59Z`);
		return now <= expiryTimestamp;
	});
};
